import { GlobalStatus, InvoiceCategoriesEnum, RodtepStatus, SaleStatusEnum, SoStatusEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { SaleOrder } from "./sale-order.entitiy";

@Entity('customer_invoice')
export class SoCustomerInvoice {

  @PrimaryGeneratedColumn("increment", { name: 'invoice_id' })
  invoiceId: number;

  @Column("int", {
    nullable: false,
    name: "sale_order_id"
  })
  saleOrderId: number;

  @Column("varchar", {
    nullable: false,
    name: "invoice_number"
  })
  invoiceNumber: string;

  @Column("date", {
    nullable: false,
    name: "invoice_date"
  })
  invoiceDate: string;
  
  @Column("date", {
    nullable: true,
    name: "order_date"
  })
  orderDate: string;

  @Column("int", {
    nullable: false,
    name: "exporter_id"
  })
  exporterId: number;

  @Column("int", {
    nullable: false,
    name: "unit_id"
  })
  unitId: number;

  @Column("int", {
    nullable: true,
    name: "customer_id"
  })
  customerId: number;

  @Column("int", {
    nullable: true,
    name: "end_customer_id"
  })
  endCustomerId: number;

  @Column("varchar", {
    nullable: true,
    name: "flight_number"
  })
  flightNumber: string;

  @Column("int", {
    nullable: false,
    name: "port_of_loading"
  })
  portOfLoading: number;

  @Column("int", {
    nullable: true,
    name: "notify_party_one"
  })
  notifyPartyOne: number;

  @Column("int", {
    nullable: true,
    name: "notify_party_two"
  })
  notifyPartyTwo: number;
  
  @Column("int", {
    nullable: true,
    name: "notify_party_three"
  })
  notifyPartyThree: number;

  @Column("int", {
    nullable: true,
    name: "notify_party_four"
  })
  notifyPartyFour: number;

  @Column("int", {
    nullable: false,
    name: "port_of_discharge"
  })
  portOfDischarge: number;

  @Column("int", {
    nullable: false,
    name: "final_destination"
  })
  finalDestination: number;

  @Column({
    type: 'enum',
    nullable: false,
    enum: SoStatusEnum,
    default: SoStatusEnum.OPEN,
    name: "status"
  })
  status: string;

  
  @Column({
    type: 'decimal', 
    precision: 6, 
    scale: 2,
    nullable: false,
    name: "exchange_rate"
  })
  exchangeRate: number;

  @Column({
    type: 'decimal', 
    precision: 10, 
    scale: 2,
    nullable: false,
    default:0,
    name: "pre_shipment_cost"
  })
  preShipmentCost: number;

  @Column("int", {
    nullable: false,
    name: "liner"
  })
  liner: number;

  @Column({
    type: 'decimal', 
    precision: 10, 
    scale: 2,
    nullable: false,
    default:0,
    name: "freight_charges"
  })
  freightCharges: number;

  @Column({
    type: 'decimal', 
    precision: 10, 
    scale: 2,
    nullable: false,
    default:0,
    name: "transportation_cost"
  })
  transportationCost: number;

  @Column({
    type: 'decimal', 
    precision: 10, 
    scale: 2,
    nullable: false,
    default:0,
    name: "other_charges"
  })
  otherCharges: number;

  @Column({
    type: 'decimal', 
    precision: 15, 
    scale: 2,
    nullable: false,
    name: "total_amount"
  })
  totalAmount: number;

  @Column({
    type: 'decimal', 
    precision: 15, 
    scale: 2,
    nullable: false,
    name: "total_inr_amount"
  })
  total_INR_amount: number;
  @Column({
    type: 'enum',
    nullable: false,
    enum: GlobalStatus,
    default: GlobalStatus.NO,
    name: "is_tax_applicable"
  })
  isTaxApplicable: string;
  @Column({
    type: 'decimal', 
    precision: 10, 
    scale: 2,
    nullable: true,
    name: "sale_commission"
  })
  saleCommission: number;
  @Column({
    type: 'decimal', 
    precision: 10, 
    scale: 2,
    nullable: true,
    name: "insurance"
  })
  insurance: number;
  @Column("varchar", {
    nullable: true,
    name: "fin_number"
  })
  finNumber: string;

  @Column("varchar", {
    nullable: true,
    name: "place_of_receipt"
  })
  placeOfReceipt: string;

  @Column("date", {
    nullable: true,
    name: "eta_date"
  })
  etaDate: string;

  @Column("datetime", {
    nullable: true,
    name: "bank_reached_date"
  })
  bankReachedDate: string;

  @Column({
    type: 'enum',
    nullable: false,
    enum: InvoiceCategoriesEnum,
    default: InvoiceCategoriesEnum.REGULAR,
    name: "invoice_category"
  })
  invoiceCategory: InvoiceCategoriesEnum;
  @Column("varchar", {
    nullable: true,
    name: "epcg_license_no"
  })
  epcgLicenseNumber: string;

  @Column("date", {
    nullable: true,
    name: "license_date"
  })
  epcgLicenseDate: string;

  @Column({
    type: 'decimal', 
    precision: 10, 
    scale: 2,
    nullable: true,
    name: "epcg_fob_value"
  })
  epcgFobValue:number
  @Column({
    type: 'decimal', 
    precision: 10, 
    scale: 2,
    nullable: true,
    name: "export_obligation"
  })
  exportObligation:number

  @Column("varchar", {
    nullable: true,
    name: "q_certificate_no"
  })
  qCertificateNo: string;



  @Column({
    type: 'decimal', 
    precision: 10, 
    scale: 2,
    nullable: true,
    name: "gross_weight"
  })
  grossWeight:number
  @Column({
    type: 'decimal', 
    precision: 10, 
    scale: 2,
    nullable: true,
    name: "frozen_weight"
  })
  frozenWeight:number

  @Column({
    type: 'int', 
    precision: 10, 
    scale: 2,
    nullable: true,
    name: "ref_no"
  })
  refNumber:number

  

  @Column("text", {
    nullable: true,
    name: "remarks"
  })
  remarks: string;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;


  @Column("varchar", {
    name: "file_name",
})
fileName: string;

@Column("varchar", {
    name: "file_path"
})
filePath: string;
  @Column({
    type: 'decimal', 
    precision: 15, 
    scale: 2,
    nullable: false,
    name: "collection"
  })
  collection: number;

  @Column({
    type: 'decimal', 
    precision: 15, 
    scale: 2,
    nullable: false,
    name: "ddb_amt"
  })
  ddbAmt: number;
  @Column({
    type:"enum",
    enum:RodtepStatus,
    nullable: true,
    name: "rodtep_status",
    default:RodtepStatus.PAYMENT_NOT_RECEIVED_AND_ICE_GATE_NOT_UPDATED
  })
  RodtepStatus: RodtepStatus;
  @Column('varchar',{
    name:'financial_year',
    nullable:true
})
financialYear : string
@Column({
  type: 'decimal', 
  precision: 15, 
  scale: 2,
  nullable: true,
  default:0,
  name: "igst_amt"
})
igstAmt: number;

  @Column('varchar',{
    name:'dc_no',
    nullable:true
})
dcNo : string
  @Column('datetime',{
    name:'dc_date',
    nullable:true
})
dcDate : string
  @Column('varchar',{
    name:'marks_and_no',
    nullable:true
})
marksAndNo : string
  @Column('varchar',{
    name:'package_type',
    nullable:true
})
packageType : string

  @Column({
    type: 'decimal', 
    precision: 10, 
    scale: 2,
    nullable: true,
    name: "net_weight"
  })
  netWeight:number

  @Column({ name: 'e_way_bill_no', type: 'varchar', length: 100, nullable: true })
eWayBillNo: string;

  @Column({ name: 'destination_address', type: 'varchar', length: 255, nullable: true })
destAddress: string;

  // @OneToOne(type=>SaleOrder, saleOrder=>saleOrder.CustomerInvDetailsInfo,{  nullable:false })
  // @JoinColumn({ name:"sale_order_id"})
  // saleOrderInfo: SaleOrder;
    @ManyToOne(() => SaleOrder, saleOrder => saleOrder.CustomerInvDetailsInfo, { nullable: false })
  @JoinColumn({ name: "sale_order_id" })
  saleOrderInfo: SaleOrder;

}
